export const getApiKey = (): string | null => {
  const raw = localStorage.getItem('user');
  if (!raw) {
    return null;
  }
  try {
    const parsed: { apikey?: string } = JSON.parse(raw);
    return parsed?.apikey ?? null;
  } catch {
    return null;
  }
};
